export default __webpack_public_path__ + "static/media/slider.c1d87a8c.svg";